<app-sidebar>
  <app-search-bar
    [index]="index"
    [recordType]="recordType"
    [sort]="sort"
    [publicView]="true"
    (tileData)="tiles.set($event)"
    (recordChange)="recordType = $event"
    (indexChange)="index = $event"
    (loadingChange)="loading.set($event)"
  ></app-search-bar>
  <app-search-results [tiles]="tiles()" [loading]="loading()" (infiniteScroll)="onInfiniteScroll($event)" />
</app-sidebar>
